import { useQueryClient } from '@tanstack/react-query';
import { apiUrlPrefix } from '../../../config';
import Cookies from 'js-cookie';
import useStore from '../state-files/zustondStoreStates';

const fetchDiscussions = async (setDiscussions, communityId) => {
  try {

    // 1. Get the raw value first
    const rawUserId = localStorage.getItem('userId');

    // 2. Only attempt the fetch if the ID exists
    if (rawUserId) {
      // Clean the ID (removing quotes if they exist)
      const cleanUserId = rawUserId.replace(/^"|"$/g, '');

      const response = await fetch(`${apiUrlPrefix}Discussion/getUserDiscussions?userId=${cleanUserId}&communityId=${communityId}`, {
        method: "GET",
        credentials: "include", // Include cookies in the request
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.ok) {
        const data = await response.json();
        setDiscussions(data); // Assuming data is an array of user objects

      } else {
        console.error("Failed to fetch users");
      }
    }
  } catch (error) {
    console.error("Error fetching users:", error);
  }
};

export default fetchDiscussions;